import type { ReactNode } from "react";
import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { CommunityPreview } from "./components/CommunityPreview";
import { LeftPanel } from "./components/LeftPanel";
import { RightPanel } from "./components/RightPanel";
import { Testimonials } from "./components/Testimonials";
import type { OnboardingSplitLayoutProps, RightPanelVariant } from "./types";

const renderRightPanelContent = (
  variant: RightPanelVariant,
  content?: ReactNode,
  communityName?: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Parameter will be used in follow-up PR
  _buildingBlocks?: string[],
) => {
  switch (variant) {
    case "testimonials":
      return <Testimonials />;
    case "community-preview":
      return <CommunityPreview communityName={communityName || ""} />;
    case "custom":
    default:
      return content;
  }
};

export const OnboardingSplitLayout = ({
  children,
  rightPanelContent,
  rightPanelVariant = "custom",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Parameter will be used in follow-up PR
  progress: _progress,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Parameter will be used in follow-up PR
  title: _title,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Parameter will be used in follow-up PR
  subtitle: _subtitle,
  communityName,
  buildingBlocks,
}: OnboardingSplitLayoutProps) => {
  const isSmScreen = useSmOrMdScreenMediaQuery();

  return (
    <div className="flex min-h-screen w-full">
      <LeftPanel>{children}</LeftPanel>

      {!isSmScreen && (
        <RightPanel>
          {renderRightPanelContent(
            rightPanelVariant,
            rightPanelContent,
            communityName,
            buildingBlocks,
          )}
        </RightPanel>
      )}
    </div>
  );
};
